<script lang="ts">
import { defineComponent } from 'vue'

import AlertNoResults from '~/vue/__fiftyfiveplus/_molecules/alerts/AlertNoResults.vue'
import CardBlog from '~/vue/__fiftyfiveplus/_molecules/cards/CardBlog.vue'
import CardJob from '~/vue/__fiftyfiveplus/_molecules/cards/CardJob.vue'
import CardOffice from '~/vue/__fiftyfiveplus/_molecules/cards/CardOffice.vue'
import FormOffice from '~/vue/__fiftyfiveplus/_organisms/forms/FormOffice.vue'
import ViewJobs from '~/vue/__fiftyfiveplus/_organisms/views/ViewJobs.vue'
import ConsentDeclaration from '~/vue/__fiftyfiveplus/_molecules/consents/ConsentDeclaration.vue'
import CardBlogGrid from '../_molecules/cards/CardBlogGrid.vue'

export default defineComponent({
    components: {
        'alert--no-results': AlertNoResults,
        'card--blog': CardBlog,
        'card--blog-grid': CardBlogGrid,
        'card--job': CardJob,
        'card--office': CardOffice,
        'consent--declaration': ConsentDeclaration,
        'form--office': FormOffice,
        'view--jobs': ViewJobs,
    }
})
</script>